import React from "react";
import { Link } from "react-router-dom";
import "./VisaCenter.css";

const visaGuides = [
  { country: "Australia", type: "Tourist/Visit Visa", flag: "🇦🇺" },
  { country: "Belgium", type: "Tourist/Visit Visa", flag: "🇧🇪" },
  { country: "Cambodia", type: "Tourist/Visit Visa", flag: "🇰🇭" },
  { country: "Canada", type: "Tourist/Visit Visa", flag: "🇨🇦" },
  { country: "China", type: "Tourist/Visit Visa | Business Visa", flag: "🇨🇳" },
  { country: "Denmark", type: "Tourist/Visit Visa", flag: "🇩🇰" },
  { country: "Egypt", type: "Tourist/Visit Visa", flag: "🇪🇬" },
  { country: "Finland", type: "Tourist/Visit Visa", flag: "🇫🇮" },
  { country: "France", type: "Tourist/Visit Visa", flag: "🇫🇷" },
  { country: "Germany", type: "Tourist/Visit Visa", flag: "🇩🇪" },
  { country: "Greece", type: "Tourist/Visit Visa", flag: "🇬🇷" },
  { country: "Hong Kong", type: "Tourist/Visit Visa", flag: "🇭🇰" },
  { country: "Indonesia", type: "Tourist/Visit Visa", flag: "🇮🇩" },
  { country: "Italy", type: "Tourist/Visit Visa", flag: "🇮🇹" },
  { country: "Japan", type: "Tourist/Visit Visa", flag: "🇯🇵" },
  { country: "New Zealand", type: "Tourist/Visit Visa", flag: "🇳🇿" },
  { country: "Pakistan", type: "Tourist/Visit Visa", flag: "🇵🇰" },
  { country: "Philippines", type: "Tourist/Visit Visa", flag: "🇵🇭" },
  { country: "Poland", type: "Tourist/Visit Visa | Business Visa", flag: "🇵🇱" },
  { country: "Portugal", type: "Tourist/Visit Visa", flag: "🇵🇹" },
  { country: "Qatar", type: "Tourist/Visit Visa", flag: "🇶🇦" },
  { country: "Saudi Arabia", type: "Umrah Visa", flag: "🇸🇦" },
  {
    country: "Singapore",
    type: "Tourist/Visit Visa | Medical Visa",
    flag: "🇸🇬",
  },
  { country: "South Korea", type: "Tourist/Visit Visa", flag: "🇰🇷" },
  { country: "Spain", type: "Tourist/Visit Visa", flag: "🇪🇸" },
  { country: "Sri Lanka", type: "Tourist/Visit Visa", flag: "🇱🇰" },
  { country: "Sweden", type: "Tourist/Visit Visa", flag: "🇸🇪" },
  { country: "Switzerland", type: "Tourist/Visit Visa", flag: "🇨🇭" },
  { country: "Tanzania", type: "Tourist/Visit Visa", flag: "🇹🇿" },
  {
    country: "Thailand",
    type: "Tourist/Visit Visa | Medical Visa",
    flag: "🇹🇭",
  },
  { country: "Turkey", type: "Tourist/Visit Visa", flag: "🇹🇷" },
];

const VisaCenter = () => {
  return (
    <div className="visa-center-container">
      {/* Hero Section */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 wow fadeInLeft" data-wow-delay="0.1s">
              <div className="visa-center-intro">
                <h2 className="display-6 mb-3">Welcome to Visa Center</h2>
                <p className="lead mb-4">
                  Visa Center, powered by{" "}
                  <span className="text-primary fw-bold">
                    Butterfly Air International
                  </span>
                  , is here to help you obtain your visas through a hassle-free
                  process. Our mission is to simplify the challenges faced by
                  travelers in Bangladesh when applying for visas.
                </p>
                <p className="mb-4">
                  For the very first time in Bangladesh, we are offering a
                  convenient{" "}
                  <span className="text-primary fw-bold">
                    Pick and Drop Visa Service
                  </span>
                  . All you need to do is gather the required documents and
                  submit them to us along with the necessary fees. We will
                  handle the rest, including submitting your passport to the
                  embassy, so you can travel with peace of mind.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 text-center wow fadeInRight"
              data-wow-delay="0.3s"
            >
              <div className="visa-center-logo">
                <img
                  src="img/visa-center-logo.png"
                  alt="Visa Center"
                  className="img-fluid"
                  style={{ maxWidth: "200px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="container-fluid bg-light py-5">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
              <div className="service-card text-center p-4 h-100">
                <div className="service-icon mb-3">
                  <i className="fas fa-heart fa-3x text-primary"></i>
                </div>
                <h4 className="mb-3">Hassle-Free</h4>
                <p>
                  Simply gather the required documents and submit them to us
                  along with the necessary fees. We will take care of the rest,
                  including submitting your passport to the embassy.
                </p>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
              <div className="service-card text-center p-4 h-100">
                <div className="service-icon mb-3">
                  <i className="fas fa-truck fa-3x text-primary"></i>
                </div>
                <h4 className="mb-3">Pick & Drop</h4>
                <p>
                  For the first time in Bangladesh, we are offering a Visa Home
                  Pick & Drop service for a minimal fee, making the visa
                  submission process more convenient and hassle-free.
                </p>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
              <div className="service-card text-center p-4 h-100">
                <div className="service-icon mb-3">
                  <i className="fas fa-user-tie fa-3x text-primary"></i>
                </div>
                <h4 className="mb-3">Visa Consultant</h4>
                <p>
                  We are here to assist you with all aspects of visa processing
                  and tour planning, anytime and anywhere.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Visa Guides Section */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <h2 className="display-5 mb-4">Visa Guides</h2>
          </div>
          <div className="row g-3">
            {visaGuides.map((guide, index) => (
              <div
                key={index}
                className={`col-lg-6 wow fadeInUp`}
                data-wow-delay={`${0.1 + index * 0.05}s`}
              >
                <Link
                  to={`/visa-details/${guide.country
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className="text-decoration-none"
                >
                  <div className="visa-guide-item d-flex align-items-center p-3 border rounded hover-effect">
                    <span
                      className="flag-icon me-3"
                      style={{ fontSize: "2rem" }}
                    >
                      {guide.flag}
                    </span>
                    <div>
                      <h6 className="mb-1 fw-bold text-dark">
                        {guide.country}:
                      </h6>
                      <span className="text-primary">{guide.type}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaCenter;
